module.exports = __webpack_public_path__ + "media/img/help_center/Student_Scholarship_Search_04-170ddf00b88cb6da3b43936a8d2fc1cb.jpg";